






















import { Component, Prop, Vue } from 'vue-property-decorator';

import DxButton from 'devextreme-vue/button';


@Component({
	components: {
		DxButton
	}
})
export default class Chip extends Vue {

	@Prop({ type: Object, default: () => ({})}) context: any;
	@Prop({ type: Boolean, default: false }) closeButton!: boolean;
	@Prop({ type: Boolean, default: false }) info!: boolean;
	@Prop({ type: Object, default: () => ({}) }) infoClasses!: Record<string, boolean>;
	@Prop({ type: String }) infoText!: string;
	@Prop({ type: String }) text!: string | null;

	get internalInfoClasses() {
		return {
			...{
				'align-middle': true,
				'bg-light-blue': true,
				'chip__info': true,
				'd-inline-block': true,
				'rounded-circle': true,
				'text-center': true
			},
			...this.infoClasses
		};
	}

	onClick() {
		this.$emit('click:close', this.context);
	}

}
